import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "./Reveal";

export const CtaSection = ({
  title = (
    <>
      Let&rsquo;s Discuss Your
      <br />
      <em className="italic font-normal text-gold-soft">Property Goals</em>
    </>
  ),
  text = "Whether you need tenant or leasehold advice, are looking to invest, or want support with a refurbishment project — we're here to help.",
}) => (
  <section data-testid="cta-section" className="relative bg-forest overflow-hidden grain">
    <span
      aria-hidden="true"
      className="absolute -right-8 -bottom-24 font-serif italic text-[220px] sm:text-[300px] leading-none text-gold-soft/5 select-none pointer-events-none"
    >
      Elin&rsquo;s
    </span>
    <div className="wrap-x relative z-[2] py-20 sm:py-24 flex flex-col lg:flex-row lg:items-center lg:justify-between gap-10">
      <Reveal>
        <h2 className="font-serif font-medium text-4xl sm:text-5xl leading-[1.05] text-cream">{title}</h2>
        <p className="text-cream/65 text-sm sm:text-[15px] leading-relaxed mt-5 max-w-md">{text}</p>
      </Reveal>
      <Reveal delay={0.15}>
        <Link to="/contact" data-testid="cta-book-button" className="btn-gold px-9 py-5">
          Book a Consultation <ArrowRight size={15} strokeWidth={2.2} />
        </Link>
      </Reveal>
    </div>
  </section>
);
